import { NgModule } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

import { GrayTextInputComponent } from './components/inputs/gray-text-input/gray-text-input.component';
import { GrayPasswordInputComponent } from './components/inputs/gray-password-input/gray-password-input.component';
import { GrayButtonComponent } from './components/buttons/gray-button/gray-button.component';
import { GrayCheckboxComponent } from './components/inputs/gray-checkbox/gray-checkbox.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GrayIconComponent } from './components/gray-icon/gray-icon.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { GraySelectInputComponent } from './components/inputs/gray-select-input/gray-select-input.component';
import { NgSelectModule } from "@ng-select/ng-select";
import {
  GrayDatePickerInputComponent
} from './components/inputs/gray-date-picker-input/gray-date-picker-input.component';
import {
  NgbDateCustomParserFormatter
} from "./components/inputs/gray-date-picker-input/ngb-date-custom-parser-formatter";
import { UserProfileImgComponent } from './components/user-profile-img/user-profile-img.component';
import { TranslateModule } from "@ngx-translate/core";
import { StaticVideoPlayerComponent } from "./components/static-video-player/static-video-player.component";
import { EmojiPickerPopupComponent } from './components/emoji-picker-popup/emoji-picker-popup.component';
import { PickerComponent } from "@ctrl/ngx-emoji-mart";
import { GrayRadioComponent } from './components/inputs/gray-radio/gray-radio.component';
import { LevelSelectorComponent } from './components/level-selector/level-selector.component';
import { NaviRouteMapComponent } from './components/navi-route-map/navi-route-map.component';
import { LevelSelectItemComponent } from './components/level-selector/level-select-item/level-select-item.component';
import { GrayRatingInputComponent } from './components/inputs/gray-rating-input/gray-rating-input.component';
import {
  GrayPillSelectInputComponent
} from './components/inputs/gray-pill-select-input/gray-pill-select-input.component';
import { RelativeTimePipe } from './pipes/relative-time.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { ReadableNumberPipe } from './pipes/readable-number.pipe';
import { ShortTextDatePipe } from './pipes/short-text-date.pipe';
import { TextTruncatePipe } from './pipes/text-truncate.pipe';
import { ShortNumberPipe } from './pipes/short-number.pipe';
import { FormatDurationPipe } from './pipes/format-duration.pipe';
import { TimeTextFormatPipe } from './pipes/time-text-format.pipe';
import { RelativeTimeAfterPipe } from './pipes/relative-time-after.pipe';
import { BypassHtmlSanitizerPipe } from './pipes/bypass-html-sanitizer.pipe';
import { VariableReplacerPipe } from './pipes/variable-replacer.pipe';
import { PastTimePipe } from './pipes/pasttime.pipe';
import { DateTimePipe } from './pipes/datetime.pipe';
import { ReadablePriceNumberPipe } from './pipes/readable-price-number.pipe';
import { LiveStreamDatePipe } from './pipes/live-stream-date.pipe';

/**
 * Shared design system: gray-* components and the common pipes. Applications provide
 * GRAY_UI_CONFIG (see ui.config.ts) with their own environment values.
 */
@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,

    NgxMaskDirective,
    NgxMaskPipe,
    NgSelectModule,
    NgbDatepickerModule,
    TranslateModule,
    PickerComponent,
    NgbPopoverModule,
  ],
  providers: [
    {
      provide: NgbDateParserFormatter,
      useClass: NgbDateCustomParserFormatter,
    },
    // The gray inputs use ngx-mask, so the module carries its config instead of every app.
    provideNgxMask(),
  ],
  declarations: [
    GrayTextInputComponent,
    GrayPasswordInputComponent,
    GrayButtonComponent,
    GrayCheckboxComponent,
    GrayIconComponent,
    GraySelectInputComponent,
    GrayDatePickerInputComponent,
    UserProfileImgComponent,
    StaticVideoPlayerComponent,
    EmojiPickerPopupComponent,
    GrayRadioComponent,
    LevelSelectorComponent,
    NaviRouteMapComponent,
    LevelSelectItemComponent,
    GrayRatingInputComponent,
    GrayPillSelectInputComponent,

    RelativeTimePipe,
    TimeFormatPipe,
    ReadableNumberPipe,
    ShortTextDatePipe,
    TextTruncatePipe,
    ShortNumberPipe,
    FormatDurationPipe,
    TimeTextFormatPipe,
    RelativeTimeAfterPipe,
    BypassHtmlSanitizerPipe,
    VariableReplacerPipe,
    PastTimePipe,
    DateTimePipe,
    ReadablePriceNumberPipe,
    LiveStreamDatePipe,
  ],
  exports: [
    GrayTextInputComponent,
    GrayPasswordInputComponent,
    GrayButtonComponent,
    GrayCheckboxComponent,
    GrayIconComponent,
    GraySelectInputComponent,
    GrayDatePickerInputComponent,
    UserProfileImgComponent,
    StaticVideoPlayerComponent,
    EmojiPickerPopupComponent,
    GrayRadioComponent,
    LevelSelectorComponent,
    NaviRouteMapComponent,
    LevelSelectItemComponent,
    GrayRatingInputComponent,
    GrayPillSelectInputComponent,

    RelativeTimePipe,
    TimeFormatPipe,
    ReadableNumberPipe,
    ShortTextDatePipe,
    TextTruncatePipe,
    ShortNumberPipe,
    FormatDurationPipe,
    TimeTextFormatPipe,
    RelativeTimeAfterPipe,
    BypassHtmlSanitizerPipe,
    VariableReplacerPipe,
    PastTimePipe,
    DateTimePipe,
    ReadablePriceNumberPipe,
    LiveStreamDatePipe,
  ],
})
export class UiModule {
}
